import constant from '@/utils/constant';
export function base64ToBlob(code, type) {
  //Base64一行不能超过76字符，超过则添加回车换行符。因此需要把base64字段中的换行符，回车符给去掉，有时候因为存在需要把加号空格之类的换回来，取决于base64存取时的规则。
  code = code.replace(/[\n\r]/g, '');
  const raw = window.atob(code);
  const rawLength = raw.length; //转换成pdf.js能直接解析的Uint8Array类型

  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], {
    type
  }); //转成pdf类型
}
export function compNamePkg(name) {
  return `『${name}』`;
}
export function orderUnZero(row) {
  if (row.channel_tag == constant.cnlYeePay && row.order_type == 1) {
    return true;
  }

  if ((row.channel_tag == constant.cnlYeePay || row.channel_tag == constant.cnlGrg) && [3, 4, 5].indexOf(row.order_type) >= 0) {
    return true;
  }

  if (row.channel_tag == constant.cnlLianLian || row.channel_tag == constant.cnlDinPay || row.channel_tag == constant.cnlSmb) {
    if ([1, 2].indexOf(row.order_type) >= 0) {
      return true;
    }
  }

  return false;
}